module.exports = __webpack_public_path__ + "img/papua_gew_guinea_icc.bf7cba2d.png";